import $ from "jquery";
import Cookie from "js-cookie";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let loadingTeasers     = false;
		const $filter          = $( '.archive__filter' );
		const $teaserContainer = $( '.archive__posts' );
		const $loadMoreButton  = $( '.archive__load-more' );
		const cookieName       = $filter.data( 'cookie' ) ? $filter.data( 'cookie' ) : new Date().getFullYear();
		const action           = $teaserContainer.data( 'action' );
		const postsPerPage     = $teaserContainer.data( 'post-count' );
		const postsTotal       = $teaserContainer.data( 'post-total' );
		const loadedYear       = $filter.data( 'loaded-year' );
		let year               = Cookie.get( cookieName ) ? parseInt( Cookie.get( cookieName ) ) : loadedYear;
		let page               = $teaserContainer.data( 'page' );
		let noMoreTeasers      = false;

		/**
		 * Insert the post teasers.
		 *
		 * @param response
		 */
		function addTeasers( response ) {
			$teaserContainer.append( response.data.markup );
		}

		/**
		 * Insert the post teasers.
		 *
		 * @param response
		 */
		function replaceTeasers( response ) {
			$teaserContainer.html( '' ).append( response.data.markup );
		}

		/**
		 * If the archive has a filter, get the values.
		 *
		 * @returns {*[]}
		 */
		function getFilterValue( element ) {
			let value = undefined;

			if ( $filter.length ) {
				if ( $( '#' + element, $filter ).length ) {
					return $( '#' + element, $filter ).val();
				}
			}

			return value;
		}

		function getFilterButtonByYear( year ) {
			return $( 'button[data-year=' + year + ']' );
		}

		/**
		 * Load more posts
		 */
		function loadMorePosts() {
			let data = {
				'action': action,
				'postsPerPage': postsPerPage,
				'postsTotal': postsTotal,
				'page': page,
			};

			let moreTeasers = $.ajax(
				{
					type: "GET",
					data: data,
					url: sedermera.ajax_url,
					success: function ( response ) {
						if ( response.data.posts === postsPerPage ) {
							page++;
						} else {
							$loadMoreButton.attr( "disabled", "disabled" );
							noMoreTeasers = true;
						}
						addTeasers( response );
						loadingTeasers = false;
					},
					failure: function ( response ) {
						console.log( response );
						loadingTeasers = false;
					}
				}
			);
		}

		function changeArchivePage( e ) {
			e.preventDefault();

			switch ( e.type ) {
				case 'click' :
					year = e.target.dataset.year;
					$( 'button', $filter ).removeClass( 'active' );
					$( e.target ).addClass( 'active' );
					break;

				case 'change' :
					year = getFilterValue( 'year' );
					break;
			}

			Cookie.set( cookieName, year );

			let data = {
				'action': action,
				'year': year,
			};

			$.ajax(
				{
					type: "GET",
					data: data,
					url: sedermera.ajax_url,
					success: function ( response ) {
						replaceTeasers( response );
					},
					failure: function ( response ) {
						console.log( response );
					}
				}
			);
		}

		//On year change fetch new year data
		if ( $filter.length ) {
			if ( $( '#year', $filter ).length ) {
				$( '#year', $filter ).on( 'change', changeArchivePage );
			}

			if ( $( '.filter-trigger', $filter ).length ) {
				$( '.filter-trigger', $filter ).on( 'click', changeArchivePage );
			}

			$( document ).ready(
				function () {
					if ( loadedYear !== year ) {
						const $yearButton = getFilterButtonByYear( year );
						$yearButton.click();
					}
				}
			);
		}

		if ( $loadMoreButton.length ) {
			$loadMoreButton.on(
				'click',
				loadMorePosts
			);
		}
	}
);
